import { render, staticRenderFns } from "./AdvancedChipsBlock.vue?vue&type=template&id=ddde5cc8&scoped=true"
import script from "./AdvancedChipsBlock.vue?vue&type=script&lang=js"
export * from "./AdvancedChipsBlock.vue?vue&type=script&lang=js"
import style0 from "./AdvancedChipsBlock.vue?vue&type=style&index=0&id=ddde5cc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde5cc8",
  null
  
)

export default component.exports